import { motion } from "framer-motion";
import { coursesAnimation } from "../animate";
import { useScroll } from "./useScroll";
import useWindowDimensions from "./useDimension";

const CoursesDetail21 = (props) => {
  const { width } = useWindowDimensions();
  const [element, controls] = useScroll(width < 1000 ? 0 : 0.25);

  return (
    <div className="details">
      <div className="images">
        <img src={props.img} alt="" />
      </div>
      <motion.div
        className="desc"
        variants={coursesAnimation}
        initial="hidden"
        animate={controls}
        ref={element}
      >
        <h2>
          <span>「離散數學」詳細課程內容:</span>
        </h2>
        <p>
          世界上所有電腦科學、資訊工程、資料管理主修的學生，都在學習電腦科學!
        </p>
        <p>
          隨著電腦科學的飛速發展，離散數學的重要性則日益彰顯。它為許多資訊學課程提供了數學基礎，包括資料結構、演算法、資料庫理論、形式語言與作業系統等。如果沒有離散數學的相關數學基礎，學生在學習上述課程中，便會遇到較多的困難。
        </p>
        <p>
          離散數學包含邏輯、證明、遞迴關係、演算法、數論與密碼學、演算法分析、圖形理論、路徑選擇、機率、排列組合、以及其他重要的程式開發演算法!
          這堂課會深入淺出探討這些概念，並且用 Python 或JavaScript (二擇一)
          來做演算法練習!
        </p>
      </motion.div>
    </div>
  );
};

export default CoursesDetail21;
